// =============================================================================
//  Copyright : 2023 semantics GmbH
//  Date      : $Date: 2025-10-12 22:58:48 +0200 (Sun, 12 Oct 2025) $
//  Author    : Olli Powroznik
//  Worker    : $Author: o.powroznik $
//  Revision  : $Rev: 157129 $
//  Purpose   : custom buttons
// =============================================================================
// ---Third-party imports
import React from 'react'
import clsx from 'clsx'

// ---Framework imports
import log from 'uix/logging'
import {KeyboardShortCut, Button} from 'uix/components'
import {WikiModalPortal} from 'uix/wiki/components'
import {Sel} from 'uix/registries'
import {useSelector} from 'uix/hooks'

// ---Local imports
import S from './modal.scss'

// ---Exports
export const Modal = ({
  caption,
  children,
  imageId,
  mobile,
  onClose,
  open,
  scrolling,
  controls,
  width = 1600,
  style,
}) => {
  let apiurl = useSelector(Sel.apiurl)
  let bgStyle = {}
  if (imageId) {
    let imgurl = `/image/pagebox/${imageId}/${width}`
    bgStyle = {
      backgroundImage: `url(${apiurl.href(imgurl)})`,
    }
  }

  let controlButtons = (
    <>
      {controls}
      <Button
        inverted
        style={{
          color: 'var(--presentation_themeColor)',
          border: '1px solid var(--presentation_themeColor)',
          margin: 'auto',
          zIndex: 30,
        }}
        icon="close"
        onClick={onClose}
      />
    </>
  )
  let topEls = <>{controlButtons}</>
  let bottomEls = caption ? <>{caption}</> : null

  return (
    <WikiModalPortal>
      <div
        className={clsx(
          open && S.modal,
          scrolling && S.scrolling,
          imageId && S.bgActive,
          mobile && S.mobile,
          !topEls && S.noTop
        )}
        style={style}
        open
      >
        <KeyboardShortCut name="Escape" onTrigger={onClose} />
        {topEls && <div className={S.topBar}>{topEls}</div>}
        <div className={S.bgImg} style={bgStyle}></div>
        <div className={clsx(S.content, caption && S.bottom, !bottomEls && S.noBottom)}>
          {children}
        </div>
        {bottomEls && <div className={S.bottomBar}>{bottomEls}</div>}
      </div>
    </WikiModalPortal>
  )
}
